import { render, staticRenderFns } from "./ReceiveDigests.vue?vue&type=template&id=290dfda4"
import script from "./ReceiveDigests.vue?vue&type=script&lang=js"
export * from "./ReceiveDigests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports